import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from "react-helmet-async";


// Log uncaught errors with more context
window.addEventListener('error', (e) => {
  console.group('window.error');
  console.log('message:', e.message);
  console.log('filename:', e.filename);
  console.log('lineno/colno:', e.lineno, e.colno);
  console.log('error object:', e.error);
  console.groupEnd();
});

// Log unhandled promise rejections
window.addEventListener('unhandledrejection', (e) => {
  console.group('unhandledrejection');
  console.log('reason:', e.reason);
  console.groupEnd();
});


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter>
    <HelmetProvider>
      <App />
      </HelmetProvider>
    </BrowserRouter>
);
